import { Flex, Box, Text } from "@chakra-ui/react";

export function FunnelSteps({
  stepCount,
  currentStep = 1,
  stepText,
  text,
  hideProgressIndicators = false,
  marginBottom,
  gap,
}: {
  stepCount?: number;
  currentStep?: number;
  stepText?: string;
  text?: string;
  hideProgressIndicators?: boolean;
  marginBottom?: string;
  gap?: string;
}) {
  return (
    <Flex
      direction="column"
      width="100%"
      pt="24px"
      mb={marginBottom || "24px"}
      alignItems="center"
      gap={gap || "24px"}
    >
      {!hideProgressIndicators && (
        <Flex gap="8px">
          {[...Array(stepCount)].map((_, i) => {
            return (
              <Box
                key={i}
                width="86px"
                height="2px"
                borderRadius="100px"
                background={i < currentStep ? "blaze.blaze" : "neutral.500"}
              />
            );
          })}
        </Flex>
      )}
      <Flex direction="column">
        {text ? (
          <Text
            fontFamily="Bricolage Grotesque"
            fontWeight="600"
            lineHeight="31.2px"
            fontSize="24px"
            color="dune.dune"
            textAlign="center"
          >
            {text}
          </Text>
        ) : null}
        {stepText && (
          <Text
            fontFamily="Bricolage Grotesque"
            fontWeight="600"
            lineHeight="31.2px"
            fontSize="24px"
            color="dune.dune"
            textAlign="center"
          >
            <Box color="blaze.blaze" display="inline">
              Step {currentStep}:
            </Box>{" "}
            {stepText}
          </Text>
        )}
      </Flex>
    </Flex>
  );
}
